export const SPACE = 32;
